import type { LocaleContent, SharedSiteConfig } from "@/types/site";

export function organizationJsonLd(
  shared: SharedSiteConfig,
  content: LocaleContent,
): Record<string, unknown> {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    description: content.site.description,
    legalName: shared.organization.legalName,
    logo: shared.organization.logo,
    name: content.site.name,
    url: shared.organization.url,
  };
}

export function websiteJsonLd(
  shared: SharedSiteConfig,
  content: LocaleContent,
): Record<string, unknown> {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    description: content.site.description,
    inLanguage: shared.locales,
    name: content.site.name,
    url: shared.organization.url,
  };
}

export function contactPageJsonLd(
  content: LocaleContent,
  url: string,
): Record<string, unknown> {
  return {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    description: content.pages.inquiry.description,
    name: content.pages.inquiry.title,
    url,
  };
}
